<div class="container-fluid" style="margin-bottom: 20px; padding-bottom: 20px;">
  <p-panel>
    <ng-template pTemplate="header" class="eca-secondary-bg" style="color: white">
      <div class="row" style="padding: 5px !important; width:100% !important;">
        <h3 style="margin-bottom: 0 !important;">
          <span style="margin-left: 15px;">
            <fa-icon [icon]="['fas', 'eye']"> </fa-icon> All Operative Observations
          </span>
        </h3>
        <div class="col pull-right">
          <app-eca-ghost-btn class="card-action-icon float-right" btnIcon="question-circle" btnType="warning" (btnClicked)="openOperativesObservationsHelp()">
          </app-eca-ghost-btn>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div *ngIf="operativeObservationLoading" class="text-center">
        <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen" secondaryColor="green">
        </fa-duotone-icon>
      </div>
      <div *ngIf="!operativeObservationLoading">
        <div class="row">
          <div class="col">
            <p-table [totalRecords]="operativeObservations?.length" #dt [value]="operativeObservations" styleClass="p-datatable-striped p-datatable-responsive-eca"
                     [scrollable]="!isOnMobile &&    operativeObservations?.length > 5" scrollHeight="500px" dataKey="observationId"
                     [responsive]="true" [columns]="columns"
                     [globalFilterFields]="['operativeName', 'operativeFirstName', 'operativeLastName','observedOn.dateTime', 'notesAsHtml','summaryInfo','observedBy','followUpOn.dateTime','observationTypeString']">
              <ng-template pTemplate="caption">
                <div class="row d-flex justify-content-between align-items-center">
                  <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12">
                    <div class="row  justify-content-lg-start justify-content-md-start justify-content-sm-between justify-content-between align-items-center">
                      <div class="col-auto">
                        <h5 class="eca-primary-text">
                          <span *ngIf="operativeObservations"> {{ operativeObservations.length }}</span>
                          Observations
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div class=" col-xl-auto col-lg-auto col-md-6 col-sm-12 ">
                    <div class="row  justify-content-lg-start justify-content-md-end justify-content-sm-between justify-content-between align-items-center">
                      <div class="col-xl-auto col-lg-auto col-md-8 col-sm-8 col-6">
                     <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                             <input pInputText type="text" class="form-control" id="ctrlSearchInput"
                                    placeholder="Search All"
                                    (input)="dt.filterGlobal($event.target.value, 'contains')">
                        </span>
                      </div>
                      <div class="col-auto">
                        <app-eca-ghost-btn btnIcon="file-excel" btnText="Export"
                                           btnType="primary" (btnClicked)="exportToExcel()"></app-eca-ghost-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 12.5%;" pSortableColumn="operativeFirstName">
                    Operative First Name
                    <p-sortIcon field="operativeFirstName"></p-sortIcon>
                  </th>
                  <th style="width: 12.5%;" pSortableColumn="operativeLastName">
                    Operative Last Name
                    <p-sortIcon field="operativeLastName"></p-sortIcon>
                  </th>
                  <th style="width: 12.5%;" pSortableColumn="observationTypeString">
                    Type
                    <p-sortIcon field="observationTypeString"></p-sortIcon>
                  </th>
                  <th style="width: 11.5%;" pSortableColumn="observedBy">
                    Observer
                    <p-sortIcon field="observedBy"></p-sortIcon>
                  </th>
                  <th style="width: 11.5%;" pSortableColumn="observedOn.dateTime">
                    Date Observed
                    <p-sortIcon field="observedOn.dateTime"></p-sortIcon>
                  </th>
                  <th style="width: 11.5%;" pSortableColumn="followUpOn.dateTime">
                    Followup
                    <p-sortIcon field="followUpOn.dateTime"></p-sortIcon>
                  </th>
                  <th style="width: 12.5%;" pSortableColumn="summaryInfo">
                    Information
                    <p-sortIcon field="summaryInfo"></p-sortIcon>
                  </th>
                  <th style="width: 15.5%;" pSortableColumn="notesAsHtml">
                    Notes
                    <p-sortIcon field="notesAsHtml"></p-sortIcon>
                  </th>
                  <th style="font-weight: bold; width: 12.5%;"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-operativeObservation let-columns="columns" style="margin: 15px;">
                <tr>
                  <td *ngFor="let col of columns">
                    <span class="p-column-title">{{col.header}}: </span>
                    <label>
                      <span *ngIf="col.type=== 'link'">
                        <a [routerLink]="['/operative',operativeObservation?.operativeId]"> {{operativeObservation[col.field]}}</a>
                      </span>
                      <span *ngIf="col.type === 'text'"> {{operativeObservation[col.field]}}</span>
                      <span *ngIf="col.type === 'date'"> {{operativeObservation[col.field]?.dateTime | date:'dd/MM/yyyy'}}</span>
                      <span *ngIf="col.type === 'type'"> {{ObservationTypeString[operativeObservation[col.field]]}}</span>
                    </label>
                    <label *ngIf="col.type === 'html'" [innerHTML]="operativeObservation[col.field] | ellipsis:70">
                    </label>
                  </td>
                  <td>
                    <div class="text-center">
                      <app-eca-row-menu (viewBtnClicked)="viewObservation(operativeObservation)"
                                        [rowMenuItems]="rowMenuItems"
                                        [contextItem]="operativeObservation">
                      </app-eca-row-menu>
                    </div>
                  </td>
                </tr>
              </ng-template>

            </p-table>
          </div>
        </div>
      </div>
    </ng-template>
  </p-panel>
</div>
